export const calculateXOffset = (
  x: number,
  {
    objectScale = 1,
    offset = 0,
  }: {
    objectScale?: number;
    offset?: number;
  } = { objectScale: 1, offset: 0 }
) => {
  return `${+x + +offset / (objectScale || 1)}px`;
};
export const calculateYOffset = (
  y: number,
  {
    objectScale = 1,
    offset = 0,
  }: {
    objectScale?: number;
    offset?: number;
  } = { objectScale: 1, offset: 0 }
) => {
  return `${+y + +offset / (objectScale || 1)}px`;
};
